export class TenantViewOperationInProgressError extends Error {
    constructor(message = "Another save of this stored view is still in progress.") {
        super(message);
        this.name = "TenantViewOperationInProgressError";
        this.code = "TENANT_VIEW_OPERATION_IN_PROGRESS";
    }
}

export class TenantViewLockUnavailableError extends Error {
    constructor() {
        super("Safe cross-tab stored-view writes are unavailable in this browser.");
        this.name = "TenantViewLockUnavailableError";
        this.code = "TENANT_VIEW_LOCK_UNAVAILABLE";
    }
}

export async function withTenantViewBrowserLock(
    identity,
    operation,
    { lockManager = globalThis.navigator?.locks } = {},
) {
    if (typeof operation !== "function") throw new TypeError("locked operation is required");
    if (!lockManager || typeof lockManager.request !== "function") {
        throw new TenantViewLockUnavailableError();
    }
    const name = `originDashboard.tenantView:${String(identity)}`;
    return lockManager.request(
        name,
        { mode: "exclusive", ifAvailable: true },
        async (lock) => {
            if (!lock) throw new TenantViewOperationInProgressError();
            return operation();
        },
    );
}
